var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback } from 'react';
import { Row, Col, Card, Text, LabelValue, Label, Button, Divider } from '@mc/ui-v4';
import { formatDateTime } from '@mc/react-format';
import { actionApiCall } from '@mc/react-app-v4';
import { EnumZboTypPripadu, ZboApi } from '../api';
import { EnumZboStavPripaduTag } from '../enums/ZboStavPripaduCaption';
import { getEnumZboTypPripaduKratkyCaption } from '../enums/ZboTypPripaduCaption';
export const PripadHeader = ({ activeInfo, onRefresh, queryDataId }) => {
    var _a, _b;
    const onOdeslatDoZbo = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!queryDataId)
            return;
        yield actionApiCall(() => __awaiter(void 0, void 0, void 0, function* () {
            yield ZboApi.odeslatDoZbo(queryDataId);
            onRefresh === null || onRefresh === void 0 ? void 0 : onRefresh();
        }));
    }), [queryDataId, onRefresh]);
    if (!(activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad)) {
        return null;
    }
    const typValue = (_a = activeInfo.pripad.typ) !== null && _a !== void 0 ? _a : activeInfo.typ;
    const stavValue = (_b = activeInfo.pripad.stav) !== null && _b !== void 0 ? _b : activeInfo.stav;
    return (React.createElement(Card, { mode: 'view', className: 'p-2', style: { minHeight: 56, border: '1px solid #d8e4f5' } },
        React.createElement("div", { className: 'd-flex flex-column' },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Text, { style: { gap: 7, fontSize: 14, fontWeight: 600 } },
                        typValue ? React.createElement("span", null, getEnumZboTypPripaduKratkyCaption(typValue !== null && typValue !== void 0 ? typValue : '').toUpperCase()) : null,
                        activeInfo.pripad.typ && activeInfo.pripad.nazev ? React.createElement(Divider, { className: 'mx-1', type: 'dot' }) : null,
                        activeInfo.pripad.nazev ? React.createElement("span", null, activeInfo.pripad.nazev) : null)),
                activeInfo.typ === EnumZboTypPripadu.ZUK ? (React.createElement(Col, { xs: 'auto' },
                    React.createElement(Button, { style: 'primary', onClick: onOdeslatDoZbo }, "Odeslat do ZBO"))) : null),
            activeInfo.pripad && (React.createElement("div", { className: 'd-flex', style: { gap: 7, marginTop: 7 } },
                activeInfo.pripad.cisloJednaci ? (React.createElement(LabelValue, { className: 'mb-0', horizontal: true, label: 'Číslo jednací' }, activeInfo.pripad.cisloJednaci)) : null,
                stavValue ? React.createElement(EnumZboStavPripaduTag, { stav: stavValue }) : null,
                activeInfo.pripad.datumAktualizace ? (React.createElement(Label, { className: 'ml-auto' },
                    "Posledn\u00ED aktualizace: ",
                    formatDateTime(activeInfo.pripad.datumAktualizace))) : null)))));
};
//# sourceMappingURL=PripadHeader.js.map